<mat-icon *ngIf="questState === 1" class="redIcon">warning_amber
</mat-icon>

<mat-icon *ngIf="questState === 2" class="orangeIcon">play_arrow
</mat-icon>

<mat-icon *ngIf="questState === 3" class="greenIcon">check
</mat-icon>